import React from "react";


const Modal1 = () => {


    return (

        <div className="container-fluid">
            <div className="modal fade" id="Modal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-center">
                            <div className="text-center w-100">
                                <h5 className="modal-title modaltitlesize" id="exampleModalLongTitle">Mountain Car DQN</h5>
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="text-center p-3">
                            <img src="https://media.giphy.com/media/MBHu5zorQTmcxXmUbw/giphy.gif" className="img-fluid rounded" alt="Responsive image"></img>
                        </div>
                        <div className="modal-body promodaltextsize">
                            <div className="p-4">
                                <h3 className="text-center">Reinforcment Learning - Deep Q-Network</h3>
                                <h4 className="text-center m-2">Language: Python</h4>
                                <h4 className="text-center m-2">Framework: Tensorflow 2
                                <br></br><br></br></h4>
                                <h4>Background<br></br><br></br></h4>
                                <ul>
                                    <li>DQN:
                                        &nbsp;
                                        A reinforcement learning algorithm that combines Q-Learning with deep neural networks to more effectively apply reinforcement learning to complex, high-dimensional environments, including video games, robotics, autonomous functionality, natural language processing (NLP), as well as trading and finance.
                                    </li>
                                    <li>Q-Learning:
                                        &nbsp;
                                        An off-policy reinforcement learning algorithm that seeks to find the best action to take given the current state. It's considered off-policy because the q-learning function learns from actions that are outside the current policy, like taking random actions, and therefore a policy isn't needed.
                                    </li>
                                    <li>Deep Neural Networks:
                                        &nbsp;
                                        An artificial neural network containing multiple layers between the input and output layers. The network can maniuplate the data within the layers of the network whether it be a linear relationship or a non-linear relationship.
                                    </li>
                                    <li>Gym OpenAI Environment:
                                        &nbsp;
                                        OpenAI provides a handful of environments to act as a toolkit for practicing and implementing Deep Q-Learning algorithms. This implementation of the MountainCar-v0 environment utulizes the DQN algorithm.
                                        <br></br><br></br> 
                                    </li>
                                </ul>

                                <h4>Model Implementation and Training <br></br><br></br></h4>
                                <p>
                                    The goal in this environment is to train the mountain car to escape from the trench and reach the flag. The environment allows the car to move left and right, with any variation of speed. The car gains more points the faster it learns to do this. This is an important learning tool for the policy. Once the car performs an action, the environment provides it a reward informing the  car where it is. Using this information, the algorithm can learn over time, by understanding what actions result in higher rewards with respect to action as well as sequence.
                                </p>
                                <p>
                                    Minor tweaking and adjustments were made on the hyperparameters in an effort to make the model learn more efficiently. The resulting model effectively learned how to complete the objective consistantly in approximately 300 episodes. It was found to be more effective at approximately 350 - 400 episodes and appeared to plataeu in effectiveness beyond approximately 450 -500 episodes. 
                                    <br></br><br></br> 
                                </p>
                                <h4>Reflection <br></br><br></br></h4>
                                <p>
                                    I am very interested in the potential applications of artificial intelligence and automation. This project was extremely educational in allowing me to gain a better understanding of how a deep learning model is implemented from the ground up. This was my first time fully controlling the states, memory allocation, as well as parameter and hyperparameter manipulation. When training deep learning models from scratch, they begin by performing random actions, and if the model is well-created, the model begins to learn over time by comprehending the reward function. It was an exciting accomplishment to see this model successfully learn to complete the objective, and I look forward to applying deep learning to more new and innovative projects.   
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button"
                            className="btn btn-outline-dark p-2 m-2 col-md-2" 
                            data-dismiss="modal">
                                Close
                            </button>
                                <a href="https://github.com/scottvcaputo/MountainCarDQN"
                                target="_blank"
                                rel="noopener noreferrer"
                                type="button" 
                                className="btn btn-outline-secondary p-2 m-2 col-md-2">
                                    <i className="fab fa-github" /> Source
                                </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Modal1;


